<template>
    <div :style="wrapperStyle">
      <img :class="classnames" :src="src" :alt="alt" :style="imageStyle" @load="ImageLoaded()" />
    </div>
    <img :class="classnames" v-if="print" :src="src" :alt="alt" id="d-printable-image" />
  </template>
  
  <script setup>
  import { ref, computed, defineProps, watch, defineEmits } from 'vue';
  
  const emit = defineEmits(['loaded']);

  // Props for image customization
  const props = defineProps({
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: 'Image',
    },
    zoom: {
      type: Number,
      required: false,
      default: 1,  // Default zoom level (1 = original size)
    },
    rotate: {
      type: Number,
      required: false,
      default: 0,  // Default rotation angle (in degrees)
    },
    color: {
      type: String,
      required: false,
      default: 'none',  // Default border color
    },
    width: {
      type: [String, Number],
      required: false,
      default: '',
    },
    height: {
      type: [String, Number],
      required: false,
      default: '',
    },
    print: { type: Boolean, default: false },
    class: { type: String, default: "" },
  });
  
  // Internal reactive variables
  const scale = ref(props.zoom);
  const rotation = ref(props.rotate);
  
const classnames = computed(() => props.class ?? "");

  // Computed style for image element
  const imageStyle = computed(() => {
    var styles =  {
      transform: `scale(${scale.value}) rotate(${rotation.value}deg)`      
    };
    if(props.width) {
      styles.width = props.width + (typeof props.width === 'number' ? 'px' : '');
    }
    if(props.height) {
      styles.height = props.height + (typeof props.height === 'number' ? 'px' : '');
    }
    return  styles;
  });
  
  // Wrapper style for color and border
  const wrapperStyle = computed(() => {
    return {
      display: 'inline-block',
      // border: `2px solid ${props.color}`,
      // padding: '10px',
      // boxSizing: 'border-box',
    };
  });
  
  // Watch for changes in props and adjust the scale and rotation accordingly
  watch(() => props.zoom, (newZoom) => {
    scale.value = newZoom;
  });
  watch(() => props.rotate, (newRotate) => {
    rotation.value = newRotate;
  });

  function ImageLoaded() {
   emit("loaded");
  }
  
  </script>
  